import { FC, useCallback, useContext, useEffect, useState } from "react";
import { ColSize, Form, ContentSection, InputForm, RowSize } from "../../../shared/components";
import { ActionButton } from "@hdi-seguros/web-components.action-button";
import { SendOutlined } from "@ant-design/icons";
import { displayErrorMessage, displaySuccessMessage, ValidateForm } from "../../../shared/utils";
import userHelper from "../../../shared/utils/userHelper";
import { InfoContext } from "../../../shared/contexts";
import EmailService, { buildSendMailRequest } from "../../../shared/services/email";
import { Form as FormAnt} from "antd";
import { DistributionListKey, MESSAGES_SENDMAIL, Recipients, RecipientsType } from "../../../shared/interfaces/services/email-services";

interface MarketingContactPageProps {
    title: string;
}

export const MarketingContactPage: FC<MarketingContactPageProps> = ({ title }) => {

    const validateForm = new ValidateForm();
    const [form] = FormAnt.useForm();
    const userInfo = userHelper.getUser();
    const pasName = userInfo?.intermediarioPrincipal?.nombreInter;
    const pasEmail = userInfo?.mail;
    const pasCode = userInfo?.intermediarioPrincipal?.codigoInter;

    const { setTitle } = useContext(InfoContext);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    
    useEffect(() => {
        setTitle('Marketing');
        /* eslint-disable-next-line */
    }, []);

    const subjectPAS = `Oficina Virtual BARBUSS – Tu consulta`;
    const subjectMKT = `Oficina Virtual – Consulta PAS`;
    const bodyPAS = MESSAGES_SENDMAIL.SUCCESS_MESSAGE_MKT;
  
    const invokeSendEmail = async (
      subject: string,
      body: string,
      distributionListKey: string,
      additionalRecipients?: Recipients[]
    ) => {
      try {
        const payload = await buildSendMailRequest(
          {
            subject: subject,
            body: body,
            includeAttachments: false,
          },
          distributionListKey,
          additionalRecipients
        );
        if (payload) await EmailService.sendMailViaLambda(payload);
      } catch (error) {
        displayErrorMessage("Hubo un error al enviar el mail");
      }
    };

    const send = useCallback(async () => {
       
        const textQuery = form.getFieldValue("textAreaForm") as string;

        const bodyMKT = `<div style="font-family: Arial, sans-serif; padding: 16px; color: #333;">
            <p><strong>Nombre PAS: </strong>${pasName}</p>
            <p><strong>Email PAS: </strong>${pasEmail}</p>
            <p><strong>Código PAS: </strong>${pasCode}</p>
            <hr style="margin: 16px 0; border: none; border-top: 1px solid #ccc;" />
            <p style="margin: 0 0 6px 0;"><strong>Mensaje:</strong></p>
            <div style="background: #f7f7f7; padding: 12px; border-radius: 6px; border: 1px solid #ddd;">${textQuery}</div>
            </div>`;        

        const pasRecipient: Recipients[] = [{
            toAddress: pasEmail!,
            toType: RecipientsType.NORMAL
        }]        
        try {
            await form.validateFields();
            setIsLoading(true);
            await invokeSendEmail(subjectPAS, bodyPAS, '', pasRecipient);
            await invokeSendEmail(subjectMKT, bodyMKT, DistributionListKey.MARKETING_CONTACT, pasRecipient);
            displaySuccessMessage(MESSAGES_SENDMAIL.SUCCESS_MESSAGE_MKT);
            form.resetFields();
        } catch (error) {}        
        finally{
            setIsLoading(false);
        }
    }, [form, subjectPAS, subjectMKT, bodyPAS, pasCode, pasEmail, pasName]);

    return (       
        <Form
            formProps={{
                form,
                name: "contact-form",
                 style: { marginBottom: 20, marginTop: 20 },
            }}
            >
            <ContentSection level='h3' title={title}>
                <RowSize rowProps={{ align: "middle", justify: 'center', }} className="marketing-contact-form" >
                    <ColSize size={50} >
                        <InputForm
                            formProps={{
                                label: 'Nombre PAS:',
                                name: 'namePasForm',
                                initialValue: pasName,
                                rules: validateForm.generateRules({
                                    label: 'nombre PAS',
                                    rules: ['required'],
                                }),
                            }}
                            inputProps={{ type: 'text', placeholder: 'Nombre', defaultValue: pasName, disabled: Boolean(pasName), }}
                        />
                    </ColSize>
                    <ColSize size={50} >
                        <InputForm
                            formProps={{
                                label: 'Correo Electrónico PAS:',
                                name: 'emailPasForm',
                                initialValue: pasEmail,
                                rules: validateForm.generateRules({
                                    label: 'correo electrónico PAS',
                                    rules: ['required'],
                                }),
                            }}
                            inputProps={{ type: 'email', placeholder: 'Email', defaultValue: pasEmail, disabled: Boolean(pasEmail) }}
                        />
                    </ColSize>
                    <ColSize size={100} >
                        <InputForm
                            formProps={{
                                label: '',
                                name: 'textAreaForm',
                                rules: validateForm.generateRules({
                                    label: 'mensaje',
                                    rules: ['required'],
                                  })
                            }}
                            inputTextAreaProps={{
                                placeholder: 'Ingrese un mensaje.',
                                required: true,
                                rows: 8,
                            }}
                            isTextArea
                        />
                    </ColSize>
                        <ActionButton
                            icon={<SendOutlined />}
                            width={150}
                            label="Enviar"
                            type="secondary"
                            className="btn-principal-barbuss"
                            onClick={send}
                            loading={isLoading}
                        />
                </RowSize>
            </ContentSection>
        </Form>
    )
}